import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { Classes } from "base/classes";
import { FileIcon, Icon } from "widgets/datadisplay";
import { Tooltip } from "widgets/feedback";
import { filePreviewAPI, usePreviewStore } from "kfplatform/filePreview";
import { getS3FileKey, bytesToSize } from "base/utils";

import { truncateFileName } from "../../common/utils/utils";
import { IMAGEBASEURL } from "../../common/utils/constant";

import styles from "../../forum/forum.css";

import CloseIcon from "../../common/icons/Close.svg";
import DownloadIcon from "../../common/icons/Download.svg";
export function CommentAttachments({
  attachments,
  removeAttachmentItem,
  readonly
}) {
  let previewImageList = attachments?.images.map((image) => ({
    fileExtension: image.preview.fileExtension,
    key: image.original.key,
    name: image.preview.name,
    isPublic: image.isPublic,
    preview: image.preview.key,
    thumbnail: image.thumbnail.key
  }));

  let isPreviewOpen = usePreviewStore((state) => state.openPreview);

  useEffect(function filePreviewEffect() {
    return () => {
      if (isPreviewOpen) {
        filePreviewAPI.close();
      }
    };
  }, []);

  return (
    <div className={`${styles.attachemetsDisplay}`}>
      {(attachments?.images?.length > 0 || attachments?.files?.length > 0) && (
        <div className={`${styles.attachmentContaier}`}>
          {attachments.images.map((image, index) => {
            return (
              <div
                key={index}
                className={`${styles.attachmentContent} ${styles.relativeContainer}`}
              >
                <img
                  src={`${IMAGEBASEURL}/${getS3FileKey(image.collage.key)}`}
                  alt={image.default.name}
                  onClick={() => {
                    filePreviewAPI.open([
                      ...previewImageList,
                      ...attachments?.files
                    ]);
                    filePreviewAPI.setFileIndex(index);
                  }}
                />
                {!readonly && (
                  <Icon
                    className={`${styles.close} ${Classes.shadow6dp}`}
                    onClick={() => removeAttachmentItem(image.default.key)}
                  >
                    <CloseIcon width={8} height={8} />
                  </Icon>
                )}
              </div>
            );
          })}
          {attachments.files.map((file, index) => {
            return (
              <div
                key={index}
                className={`${styles.attachmentContent} ${
                  file.fileExtension !== "gif" &&
                  `${styles.attachmentContentFile}`
                } ${styles.relativeContainer}`}
              >
                {file.fileExtension && file.fileExtension === "gif" && (
                  <div
                    onClick={() => {
                      filePreviewAPI.open([
                        ...previewImageList,
                        ...attachments?.files
                      ]);
                      filePreviewAPI.setFileIndex(
                        attachments.images.length + index
                      );
                    }}
                  >
                    <img
                      alt="gif"
                      src={`${IMAGEBASEURL}/${getS3FileKey(file.key)}`}
                    />
                  </div>
                )}
                {file.fileExtension && file.fileExtension !== "gif" && (
                  <Tooltip content={file.name}>
                    <div
                      className={styles.fileContent}
                      onClick={() => {
                        filePreviewAPI.open([
                          ...previewImageList,
                          ...attachments?.files
                        ]);
                        filePreviewAPI.setFileIndex(
                          attachments.images.length + index
                        );
                      }}
                    >
                      <FileIcon
                        type={file.fileExtension}
                        width={64}
                        height={64}
                      />
                      <div className={styles.fileText}>
                        <p className={`smallplus`}>
                          {truncateFileName(file.name)}
                          <p className={`tiny`}>
                            {bytesToSize(file.size, 2, true)}
                            <Icon>
                              <DownloadIcon />
                            </Icon>
                          </p>
                        </p>
                      </div>
                    </div>
                  </Tooltip>
                )}
                {!readonly && (
                  <Icon
                    className={`${styles.close} ${Classes.shadow6dp}`}
                    onClick={() => removeAttachmentItem(file.key)}
                  >
                    <CloseIcon width={8} height={8} />
                  </Icon>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

CommentAttachments.propTypes = {
  attachments: PropTypes.array,
  removeAttachmentItem: PropTypes.func,
  readonly: PropTypes.bool
};
